import { http } from 'lib/services/http';
import { billingServiceBaseUrl } from 'constants/apiUrls';

const BILLING_API_PATH = `${billingServiceBaseUrl}`;

export const updateBillingContact = (managerId, payload) => {
  return http.put(`${BILLING_API_PATH}/users/manager/${managerId}`, payload);
};
